import * as d3 from "d3";
import $ from "jquery";

import {
  devicesOfSerial,
  devNeedsAddon,
  GET_SER_BORDER_WIDTH,
  GET_SER_MARG,
  getD3DevTopCenter,
  getDeviceById,
  getFirstOccurrenceOfDev,
  getGroupsOfDevice,
  getNote,
  getRoomById,
  getSerialById,
  getSerialOfDeviceId,
  getSerialPosProps,
  getSerObj,
  getSuitablePlaceNearby,
  isDeviceMerged,
  isDeviceMergedById,
  isDInGroup,
  isPointOutOfBounds,
  isPointSnapped,
  serialRealLength,
  uDev,
  UDevGlobals,
  wallsOfRoom
} from "src/components/Planner/planner/uDev";
import {
  canBeDevMerged,
  deleteDevNote,
  getMergedDevice,
  getProductById,
  modDevNote,
  sendDevNote,
  setAndSendSerialPosition
} from "src/components/Planner/planner/uDev-dom";
import {
  areProblemsFixed,
  checkTooBigDevices,
  deviceOnClick,
  deviceOnMouseEnter,
  devicesChanged,
  drawDevSymbolForDev,
  drawDevSymbols,
  enderrorCorrectMode,
  firstOfType,
  getDevTransform,
  hideRotateAndDeviceTools,
  initDeviceEvents,
  isPlannerMetric,
  placeFree,
  PUTDevData,
  recalcRoomDevs,
  redrawQuantityBadgeForDev,
  redrawQuantityBadges,
  refreshDArray,
  removeDeviceFromCacheLocal,
  removeDeviceFromGroupsLocal,
  rotatableOnMouseEnter,
  setMouseDownXY,
  setPageXY,
  unHighlight,
  updateDev
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {
  getDColsNum,
  getDRowsNum,
  SERIAL_SPACING
} from "src/components/Planner/planner/serial-layout";
import {
  mouseupGroup,
  recalcSwitchPNIDs,
  redrawGroups
} from "src/components/Planner/planner/grouping";
import {
  isMotionSensorMode,
  isMotionSensorOrCamera,
  redrawMotionSensors
} from "src/components/Planner/planner/movsen";
import {
  getSerialConnectedPair,
  getSerialConnectionForSerialId,
  getSerialConnectionProps,
  isSerialConnectedWithOther
} from "src/components/Planner/planner/serialConnections";
import {
  addDevToSerial,
  ajaxSetSerialProps,
  getSerialHeightForPNID,
  highlightAvailableSerials,
  redrawSerializerBorders,
  removeDeviceFromSerial,
  serialAlreadyContainsBadgedDevType
} from "src/components/Planner/planner/serialConnections-dom";
import {cmToInch, roundToMax2} from "src/utils/imperialConverter";
import {
  doesDeviceFitRoom,
  snapDeviceToWall,
  uMath
} from "src/components/Planner/planner/uMath";
import {doesSerialFitRoom} from "src/components/Planner/planner/deviceGeometry";
import {redrawWifiIfNeeded} from "src/components/Planner/planner/wificalc-dom";
import {
  getCategoryOpacity,
  isCategoryShown
} from "src/components/Planner/planner/categoryDisplayHandler";
import {
  canModifyProjectByRoomId,
  canPutDifferentDeviceByRoomId,
  ControllerGlobals,
  deepCopy,
  getAuthHeader,
  MODKEYS_STATE,
  removeDeviceFromCanPutDifferentDeviceByRoomIdCache,
  toastInfoImportantSingle,
  toastNotProError
} from "src/components/Planner/controller";
import {calcImageURL} from "src/utils/url";
import {
  getMeasurementsOfSerial,
  isDInMeasures,
  redrawMeasurementsOf,
  removeDeviceFromMeasuresLocal
} from "src/components/Planner/planner/measurement";
import {
  redrawNotes,
  showAddSoleNoteModal
} from "src/components/Planner/planner/notes";
import {
  showDragAndDropOverlay,
  testIfDraggable
} from "src/components/Planner/planner/draganddrop";
import {snackError} from "src/utils/legacyUiAdapter";
import {ROOT_URI} from "src/utils/constants";
import {ts} from "src/utils/translate";
import {
  MoveDeviceAction
} from "src/components/Planner/planner/history/device-actions";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";

export let DeviceDrawingGlobals = {
  wannaRedrawAfterDrag: false,
}

let devices_d3;

export function removeDevNode(deviceId) {
    var node = d3.select('[data-deviceId="' + deviceId + '"]').node();
    if (node) {
        d3.select(node.parentNode).remove();
    }
}

export function redrawDevice(deviceId) {
    var dev = getDeviceById(deviceId);
    var returnedD;
    if (dev && dev.serializable) {
        /* dev = getFirstOccurrenceOfDev(dev); */
        // redrawing serialized device
        var ser = getSerialOfDeviceId(deviceId);
        if (ser) {
            if (dev.initialFakeDeviceId) {
                removeDevNode(dev.initialFakeDeviceId);
            }
            // it is already in a frame
            returnedD = redrawSerial(ser.id);
        }
        else {
            // the serial is deleted or does not exist yet
            var node = d3.select('[data-deviceId="' + deviceId + '"]').node();
            if (node) {
                // the serial existed, but it was deleted from memory, but we still need to delete it
                const parentSerG = node.parentNode;
                if (parentSerG.classList.contains('serial')) {
                    var serId = d3.select(node.parentNode).attr('data-serialId');
                    returnedD = redrawSerial(serId);
                }
                else if (parentSerG.classList.contains('serial-connected')) {
                    redrawDevices();
                }
                else {
                    // very weird case when a serializable device is not in a serial but the user deletes it
                    redrawSingleDevice(deviceId);
                }
            }
            else {
                // the device is serializable but we couldn't create the frame because of permission error
                redrawSingleDevice(deviceId);
            }
        }
    } else if(isDeviceMergedById(deviceId)){
        redrawDevices();
    }
    else {
        // redrawing non-serialized device or custom item
        returnedD = redrawSingleDevice(deviceId);
    }

    refreshDArray(PlannerGlobals.sizeErrorHelper.problemDevices);

    if (returnedD) {
        if (isDInGroup(returnedD)) {
            redrawGroups(true, returnedD);
        }
        if (isDInMeasures(returnedD)) {
            redrawMeasurementsOf(returnedD);
        }
        if (Array.isArray(returnedD.devices) && returnedD.devices.length) {
            if (isMotionSensorOrCamera(returnedD.devices[0]) && isMotionSensorMode()) {
                redrawMotionSensors(true);
            }
        }
    }
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
        checkTooBigDevices(true);
    }
}

export function redrawSingleDevice(deviceId) {
    var dev = getDeviceById(deviceId);
    /* console.log('single', deviceId, dev) */
    PlannerGlobals.svg.selectAll('[data-serDevId="' + deviceId + '"]').remove();

    if (!dev) {
        removeDevNode(deviceId);
        return;
    }
    recalcRoomDevs();

    if (dev.deleted || !isCategoryShown(dev.category_id)) {
        if (!(canBeDevMerged(dev) && PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id] && !dev.serializable)) {
            return;
        }
    }

    if (!PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id]) {
        return;
    }

    if (canBeDevMerged(dev) && !dev.serializable) {
        var firstDevId = PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id][0].deviceId;
        if (firstDevId !== deviceId) {
            return redrawSingleDevice(PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id][0].deviceId);
        }
    }

    var devicesElem = d3.select('#devicesMain');

    let isMerged = false;
    //dev.firstOfTypeInRoom = roomDevs[dev.roomId][dev.product_name_id][0].deviceId == dev.deviceId;
    if (
        isDeviceMerged(dev) && !dev.serializable
        //|| (mergedDevice.length === 0 && dev.mergeable) // hogy leszedjük a bade-et
        || dev.mergeable // hogy leszedjük a bade-et
    ) {
        let mergeDeviceArray = PlannerGlobals.mergedDevice.filter(merged => merged.merge_plan_objects_id === dev.deviceId);

        dev.qty = mergeDeviceArray.length + 1; // önmaga miatt +1
        dev.similarDeviceIds = PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id].map(function (dev2) { return dev2.deviceId; });
        isMerged = true;
    }
    if (isMerged === false || dev.serializable || 1) {

        var devObj = {
            id: null,
            devices: [dev],
            x: dev.x,
            y: dev.y,
            roomId: dev.roomId,
            angle: ("angle" in dev && dev.angle) ? dev.angle : 0
        }

        var devElem = PlannerGlobals.svg.selectAll('[data-serDevId="' + dev.deviceId + '"], [data-serDevId="' + dev.fakeDeviceId + '"]');
        devElem.remove();

        var devG = devicesElem.append('g')
        .datum(devObj)
        .attr('transform', getDevTransform(devObj))
        .attr('class', 'planner-rotatable')
        .attr('data-serDevId', dev.deviceId)
        .on("mousedown", function (event) {
            setPageXY(event);
            setMouseDownXY();
            if (event.which != 1 || ControllerGlobals.currentlyDraggedDevice) {
                event.stopImmediatePropagation();
            }
        })
        .call(PlannerGlobals.drag)
        .on("mouseover", function (event, d) {
            testIfDraggable(d);
        });
        const productIdClass = 'productId' + dev.product_id;
        var devImg = devG.append("svg:image")
        .datum(dev)
        .attr('width', PlannerGlobals.DEVICE_SIZE)
        .attr('height', PlannerGlobals.DEVICE_SIZE)
        .attr('x', 0)
        .attr('y', 0)
        .attr('id', dev.deviceId)
        .attr('data-deviceId', dev.deviceId)
        .attr('data-roomId', dev.roomId)
        .attr('data-qty', dev.qty)
        .attr('data-productNameId', function (d) { return d.product_name_id; })
        .attr('xlink:href', function () {
                return calcImageURL(dev.image);
            })
        .attr('class', dev.ghost ? 'dev-ghost' + productIdClass : 'device uplan-touchable ' + productIdClass)
        .style('opacity', dev.ghost ? 0.5 : getCategoryOpacity(dev.category_id));

        $('#' + dev.deviceId).on('click', deviceOnClick)
        .on('mouseenter', deviceOnMouseEnter)
        .on('mouseenter', rotatableOnMouseEnter);

        redrawQuantityBadgeForDev(dev, devImg.node());
        if (PlannerGlobals.symbols_on || PlannerGlobals.notes_on) {
            drawDevSymbolForDev(dev, devImg.node());
        }
    }
    return devObj;
}

export function redrawSerialConnectionOf(serialId) {
    const conn = getSerialConnectionForSerialId(serialId);
    if (!conn) {
        // shouldnt be possible to get here
        return redrawDevices();
    }
    const connPropObj = getSerialConnectionProps(conn.id);
    if (!connPropObj) {
        // shouldnt be possible to get here either
        return redrawDevices();
    }

    const devicesElem = PlannerGlobals.svg.select('#devicesMain');

    // clean up parent elem
    devicesElem.selectAll(`[data-serConnId="${conn.id}"]`).remove();

    // clean up serials if any is remaining separately
    connPropObj.serials.forEach(ser => {
        const realSer = getSerialById(ser.id);
        const possibleSerIds = [realSer.id, realSer.fakeSerial, realSer.initialFakeSerialId]
        .filter(x => !!x)
        .map(x => `[data-serialId="${x}"]`)
        .join(', ');

        devicesElem.selectAll(possibleSerIds).remove();
    });

    recalcRoomDevs();

    const serialGTargets = {};

    var serConnG = devicesElem
    .append('g')
    .datum(connPropObj)
    .attr('transform', getDevTransform(connPropObj))
    .attr('class', 'serial-connection planner-rotatable')
    .attr('data-serConnId', function (d) { return d.connId || null })
    .on("mousedown", function (event) {
        setPageXY(event);
        setMouseDownXY();
        if (event.which != 1 || ControllerGlobals.currentlyDraggedDevice) {
            event.stopImmediatePropagation();
        }
    })
    .call(PlannerGlobals.drag)
    .on("mouseover", function (event, d) {
        testIfDraggable(d);
    })
    .each(function (serObj, i) {

        function getDevColIdx(d, i) {
            return serObj.deviceIdsWithColRowIdx[d.deviceId].colIdx;
        }

        function getDevRowIdx(d, i) {
            return serObj.deviceIdsWithColRowIdx[d.deviceId].rowIdx;
        }


        const allColsNum = serObj.allColsNum;
        serObj.serials.forEach(ser => {
            const currColNum = ser.colNum;
            const colNumDiff = allColsNum - currColNum;
            const extraTarget = d3.select(this)
            .append('g')
            .attr('class', 'serial-connected')
            .attr('data-serialId', ser.serialId)
            .attr('data-serialDir', ser.direction)
            .attr('data-serialDevNum', ser.serObj.devices.length)
            .attr('data-serialHiddenDevs', ser.serObj.hiddenDevsNum)
            .attr('transform', `translate(${colNumDiff / 2 * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING)},${ser.rowIdx * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING)})`);

            serialGTargets[ser.serialId] = extraTarget;
        });

        const d3This = d3.select(this);
        serObj.devices.forEach((dev, devIdx) => {
            const tar = dev.serialId && dev.serialId in serialGTargets ? serialGTargets[dev.serialId] : d3This;
            const productIdClass = 'productId' + dev.product_id;
            tar.append('svg:image')
            .datum(dev)
            .attr('width', PlannerGlobals.DEVICE_SIZE)
            .attr('height', PlannerGlobals.DEVICE_SIZE)
            .attr('x', function (d) { return getDevColIdx(d, devIdx) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING); })
            .attr('y', function (d) { return getDevRowIdx(d, devIdx) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING); })
            .attr('id', function (d) { return d.deviceId; })
            .attr('data-deviceId', function (d) { return d.deviceId; })
            .attr('data-productNameId', function (d) { return d.product_name_id; })
            .attr('data-roomId', function (d) { return d.roomId; })
            .attr('data-qty', function (d) { return d.qty; })
            .attr('xlink:href', function (d) {
                    return calcImageURL(d.image);
                })
            .attr('class', function (d) { if (d.ghost || d.sameIsGhost) return "dev-ghost " + productIdClass; else return "device uplan-touchable " + productIdClass; })
            .style('opacity', function (d) {
                if (d.ghost || d.sameIsGhost) {
                    return 0.5;
                }
                else {
                    return getCategoryOpacity(d.category_id);
                }
            });
        })

    });

    connPropObj.devices.forEach(function (dev) {
        var node = $('#' + dev.deviceId);
        node.on('click', deviceOnClick)
        .on('mouseenter', deviceOnMouseEnter)
        .on('mouseenter', rotatableOnMouseEnter);

        redrawQuantityBadgeForDev(dev, node[0]);
        if (PlannerGlobals.symbols_on || PlannerGlobals.notes_on) {
            drawDevSymbolForDev(dev, node[0]);
        }
    });

    connPropObj.serials.forEach((ser, idx) => {
        const serG = serialGTargets[ser.id];
        const serObj = ser.serObj;
        const posProps = getSerialPosProps(serObj.devices.length, serObj.direction);

        serG.insert('rect', ':first-child')
        .attr('x', -GET_SER_MARG())
        .attr('y', -GET_SER_MARG())
        .attr('rx', 2 * PlannerGlobals.DEVICE_SIZE / 20)
        .attr('ry', 2 * PlannerGlobals.DEVICE_SIZE / 20)
        .attr('fill', 'rgba(255,255,255,0.3)')
        .attr('width', posProps.width)
        .attr('height', posProps.height)
        .attr('stroke', 'black')
        .attr('stroke-width', GET_SER_BORDER_WIDTH())
        .attr('data-serialIdRect', ser.id);


        let heightTxtY = PlannerGlobals.DEVICE_SIZE - (PlannerGlobals.DEVICE_SIZE / 3);
        if (idx === 0 && ser.direction === "vertical") {
            heightTxtY += (serObj.devices.length - 1) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING);
        }

        const textSelection = addHeightTextToSerial(serG, ser, heightTxtY);
        rotateHeightTextForSerial(ser, textSelection);
    });

    return connPropObj;

    //redrawDevices(); // TODO REMOVE
}

export function addHeightTextToSerial(serG, ser, heightTxtY) {
    // add text
    const textSelection = serG.append('text')
    .text(isPlannerMetric() ? `${roundToMax2(ser.height)} cm` : `${roundToMax2(cmToInch(ser.height))} in`)
    .attr('text-anchor', 'end')
    .attr('x', -PlannerGlobals.DEVICE_SIZE / 6)
    .attr('y', heightTxtY)
    .attr('font-size', PlannerGlobals.DEVICE_SIZE / 3)
    .attr('color', 'black')
    .attr('class', 'height-txt');

    // add bbox
    const bbox = textSelection.node().getBBox();
    const pad = 0.3;
    serG.insert('rect', ':first-child')
    .attr('x', bbox.x - pad)
    .attr('y', bbox.y - pad)
    .attr('width', bbox.width + pad * 2)
    .attr('height', bbox.height + pad * 2)
    .attr('fill', 'white')
    .attr('fill-opacity', 0.5)
    .attr('rx', PlannerGlobals.DEVICE_SIZE / 6)
    .attr('ry', PlannerGlobals.DEVICE_SIZE / 6)
    .attr('class', 'height-txt-rect');

    return textSelection;
}

export function rotateHeightTextForSerial(ser, textSelection) {
    const serialAngle = uMath.normalizeAngle(ser.angle || 0);

    if (serialAngle > 91 && serialAngle < 269) {
        const bbox = textSelection.node().getBBox();
        const rotateCenter = {
            x: bbox.x + bbox.width / 2,
            y: bbox.y + bbox.height / 2
        };
        textSelection.attr('transform', `rotate(180 ${rotateCenter.x} ${rotateCenter.y})`);
    }
}

export function redrawSerial(serialId) {
    if (isSerialConnectedWithOther(serialId)) {
        return redrawSerialConnectionOf(serialId);
    }
    var ser = getSerialById(serialId);
    /* console.log('serial', serialId, ser) */
    if (!ser || ser.deleted || !ser.deviceIds || !ser.deviceIds.length) {
        PlannerGlobals.svg.selectAll('[data-serialId="' + serialId + '"]').remove();
        return;
    }
    if (ser.initialFakeSerialId) {
        PlannerGlobals.svg.selectAll('[data-serialId="' + ser.initialFakeSerialId + '"]').remove();
    }
    var serialId = ser.id;

    recalcRoomDevs();

    var serObj = getSerObj(ser);
    var devicesElem = PlannerGlobals.svg.select('#devicesMain');

    var serElem = PlannerGlobals.svg.selectAll('[data-serialId="' + serialId + '"], [data-serialId="' + ser.fakeSerialId + '"]');
    serElem.remove();

    var serG = devicesElem
    .append('g')
    .datum(serObj)
    .attr('transform', getDevTransform(serObj))
    .attr('class', 'serial planner-rotatable')
    .attr('data-serialId', serialId)
    .on("mousedown", function (event) {
        setPageXY(event);
        setMouseDownXY();
        if (event.which != 1 || ControllerGlobals.currentlyDraggedDevice) {
            event.stopImmediatePropagation();
        }
    })
    .call(PlannerGlobals.drag)
    .on("mouseover", function (event, d) {
        testIfDraggable(d);
    })
    .each(function (d, i) {
        function getDevColIdx(d2, i) {
            if (d.direction === "vertical") {
                return 0;
            }
            return i;
        }

        function getDevRowIdx(d2, i) {
            if (d.direction === "vertical") {
                return i;
            }
            return 0;
        }
        const productIdClass = 'productId' + d.product_id;
        d3.select(this)
        .selectAll('image')
        .data(d.devices)
        .enter()
        .append("svg:image")
        .attr('width', PlannerGlobals.DEVICE_SIZE)
        .attr('height', PlannerGlobals.DEVICE_SIZE)
        .attr('x', function (d, i) { return getDevColIdx(d, i) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) })
        .attr('y', function (d, i) { return getDevRowIdx(d, i) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING) })
        .attr('id', function (d) { return d.deviceId; })
        .attr('data-deviceId', function (d) { return d.deviceId; })
        .attr('data-roomId', function (d) { return d.roomId; })
        .attr('data-productNameId', function (d) { return d.product_name_id; })
        .attr('data-qty', function (d) { return d.qty; })
        .attr('xlink:href', function (d) {
                return calcImageURL(d.image);
            })
        .attr('class', function (d) {
          if (d.ghost || d.sameIsGhost) {
            return "dev-ghost " + ' productId' + d.product_id;
          } else {
            return "device uplan-touchable " + ' productId' + d.product_id;
          }
        })
        .style('opacity', function (d) {
            if (d.ghost || d.sameIsGhost) {
                return 0.5;
            }
            else {
                return getCategoryOpacity(d.category_id);
            }
        });
    });


    serObj.devices.forEach(function (dev) {
        var node = $('#' + dev.deviceId);
        node.on('click', deviceOnClick)
        .on('mouseenter', deviceOnMouseEnter)
        .on('mouseenter', rotatableOnMouseEnter);

        redrawQuantityBadgeForDev(dev, node[0]);
        if (PlannerGlobals.symbols_on || PlannerGlobals.notes_on) {
            drawDevSymbolForDev(dev, node[0]);
        }
    });

    const posProps = getSerialPosProps(serObj.devices.length, serObj.direction);

    serG.insert('rect', ':first-child')
    .attr('x', -GET_SER_MARG())
    .attr('y', -GET_SER_MARG())
    .attr('rx', 2 * PlannerGlobals.DEVICE_SIZE / 20)
    .attr('ry', 2 * PlannerGlobals.DEVICE_SIZE / 20)
    .attr('fill', 'rgba(255,255,255,0.3)')
    .attr('width', posProps.width)
    .attr('height', posProps.height)
    .attr('stroke', 'black')
    .attr('stroke-width', GET_SER_BORDER_WIDTH())
    .attr('data-serialIdRect', serialId);

    const textSelection = addHeightTextToSerial(serG, ser, PlannerGlobals.DEVICE_SIZE - (PlannerGlobals.DEVICE_SIZE / 3));
    rotateHeightTextForSerial(ser, textSelection);

    return serObj;
}

export function redrawDevices() {
    if (PlannerGlobals.DRAG_HELPER.draggedD3Dev) {
        DeviceDrawingGlobals.wannaRedrawAfterDrag = true;
        return;
    }
    PlannerGlobals.svg.selectAll('.errorHighlight').remove();
    d3.select('.devices').remove();
    var devicesElem = PlannerGlobals.container.append("g").attr("class", "devices").attr("id", "devicesMain");

    var devicesInSerials = [];

    for (var i = 0; i < PlannerGlobals.serials.length; i++) {
        devicesInSerials = devicesInSerials.concat(PlannerGlobals.serials[i].deviceIds);
    }

    //putting serialized devices into their serializers
    var serializedDevices = PlannerGlobals.serials.map(ser => getSerObj(ser))
    .filter(function (ser) { return ser.devices && ser.devices.length > 0 && !isSerialConnectedWithOther(ser.id); });

    PlannerGlobals.serialConnections.forEach(conn => {
        const connObj = getSerialConnectionProps(conn.id);
        if (connObj) {
            serializedDevices.push(connObj);
        }
    });

    recalcRoomDevs();

    //putting unserialized devices into their own 'serializer'
    for (var i = 0; i < PlannerGlobals.devices.length; i++) {
        var isDeviceInSerial = devicesInSerials.findIndex(function (id) {
            return id == PlannerGlobals.devices[i].deviceId;
        }) != -1;

        if (!isDeviceInSerial && isCategoryShown(PlannerGlobals.devices[i].category_id)) {

            var dev = PlannerGlobals.devices[i];
            let isMerged = false;
            if (
                isDeviceMerged(dev) && !dev.serializable
                //|| (mergedDevice.length === 0 && dev.mergeable) // hogy leszedjük a bade-et
                || dev.mergeable // hogy leszedjük a bade-et
            ) {
                let mergeDeviceArray = PlannerGlobals.mergedDevice.filter(merged => merged.merge_plan_objects_id === dev.deviceId);

                dev.qty = mergeDeviceArray.length + 1; // önmaga miatt +1
                dev.similarDeviceIds = PlannerGlobals.roomDevs[dev.roomId][dev.product_name_id].map(function (dev2) { return dev2.deviceId; });
                let mergedDeviceArray = PlannerGlobals.mergedDevice.filter(merged => merged.merged_plan_objects_id === dev.deviceId);
                // ha olyan eszköz van amit BEmergeltek azt nem jelenítjük meg
                if (mergedDeviceArray.length > 0) {
                    isMerged = true;
                }
            }

            if (isMerged === false || dev.serializable) {
                serializedDevices.push({
                    id: null,
                    devices: [dev],
                    x: dev.x,
                    y: dev.y,
                    roomId: dev.roomId,
                    angle: ("angle" in dev && dev.angle) ? dev.angle : 0
                });
            }
        }
    }

    devices_d3 = devicesElem
    .selectAll('g')
    .data(serializedDevices)
    .enter()
    .append('g')
    .attr('transform', getDevTransform)
    .attr('class', function (d) {
            if (d.id) {
                return 'serial planner-rotatable';
            }
            else if (d.connId) {
                return 'serial-connection planner-rotatable';
            }
            else {
                return 'planner-rotatable';
            }
        })
    .attr('data-serConnId', function (d) { return d.connId || null })
    .attr('data-serialId', function (d) { return d.id || null; })
    .attr('data-serDevId', function (d) { return (!d.id && !d.connId) ? d.devices[0].deviceId : null })
    .on("mousedown", function (event) {
        setPageXY(event);
        setMouseDownXY();
        if (event.which != 1 || ControllerGlobals.currentlyDraggedDevice) {
            event.stopImmediatePropagation();
        }
    })
    .call(PlannerGlobals.drag)
    .on("mouseover", function (event, d) {
        testIfDraggable(d);
    })
    .each(function (serObj, i) {

        function getDevColIdx(d, i) {
            if (typeof serObj.deviceIdsWithColRowIdx && serObj.deviceIdsWithColRowIdx && d.deviceId in serObj.deviceIdsWithColRowIdx) {
                return serObj.deviceIdsWithColRowIdx[d.deviceId].colIdx;
            }
            else if (serObj.direction === "vertical") {
                return 0;
            }
            return i;
        }

        function getDevRowIdx(d, i) {
            if (typeof serObj.deviceIdsWithColRowIdx && serObj.deviceIdsWithColRowIdx && d.deviceId in serObj.deviceIdsWithColRowIdx) {
                return serObj.deviceIdsWithColRowIdx[d.deviceId].rowIdx;
            }
            else if (serObj.direction === "vertical") {
                return i;
            }
            return 0;
        }

        const extraTargets = {};
        if (Array.isArray(serObj.serials)) {
            const allColsNum = serObj.allColsNum;
            serObj.serials.forEach(ser => {
                const currColNum = ser.colNum;
                const colNumDiff = allColsNum - currColNum;
                const extraTarget = d3.select(this)
                .append('g')
                .attr('class', 'serial-connected')
                .attr('data-serialId', ser.serialId)
                .attr('data-serialDir', ser.direction)
                .attr('data-serialDevNum', ser.serObj.devices.length)
                .attr('data-serialHiddenDevs', ser.serObj.hiddenDevsNum)
                .attr('transform', `translate(${colNumDiff / 2 * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING)},${ser.rowIdx * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING)})`);

                extraTargets[ser.serialId] = extraTarget;
            });
        }

        const d3This = d3.select(this);
        serObj.devices.forEach((dev, devIdx) => {
            const tar = dev.serialId && dev.serialId in extraTargets ? extraTargets[dev.serialId] : d3This;
            const productIdClass = 'productId' + dev.product_id;
            tar.append('svg:image')
            .datum(dev)
            .attr('width', PlannerGlobals.DEVICE_SIZE)
            .attr('height', PlannerGlobals.DEVICE_SIZE)
            .attr('x', function (d) { return getDevColIdx(d, devIdx) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING); })
            .attr('y', function (d) { return getDevRowIdx(d, devIdx) * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING); })
            .attr('id', function (d) { return d.deviceId; })
            .attr('data-deviceId', function (d) { return d.deviceId; })
            .attr('data-roomId', function (d) { return d.roomId; })
            .attr('data-productNameId', function (d) { return d.product_name_id; })
            .attr('data-qty', function (d) { return d.qty; })
            .attr('xlink:href', function (d) {
                    return calcImageURL(d.image);
                })
            .attr('class', function (d) {
              if (d.ghost || d.sameIsGhost) {
                return "dev-ghost " + productIdClass;
              } else {
                return "device uplan-touchable " + productIdClass;
              }
            })
            .style('opacity', function (d) {
                if (d.ghost || d.sameIsGhost) {
                    return 0.5;
                }
                else {
                    return getCategoryOpacity(d.category_id);
                }
            });
        })

    });


    refreshDArray(PlannerGlobals.sizeErrorHelper.problemDevices);
    initDeviceEvents();
    //add grouping lines
    redrawSerializerBorders();
    redrawQuantityBadges();
    redrawGroups();
    if (PlannerGlobals.sizeErrorHelper.errorCorrectMode) {
        checkTooBigDevices(true);
    }
    if (ControllerGlobals.currentlyDraggedDevice && ControllerGlobals.currentlyDraggedDevice.serializable && MODKEYS_STATE.shift) {
        highlightAvailableSerials(ControllerGlobals.currentlyDraggedDevice);
    }
    if (PlannerGlobals.symbols_on || PlannerGlobals.notes_on) {
        drawDevSymbols();
    }
    if (PlannerGlobals.notes_on) {
        redrawNotes();
    }
    if (PlannerGlobals.mode == 'wificalc') {
        redrawWifiIfNeeded();
    }
    if (isMotionSensorMode()) {
        d3.select('#motionsensors').remove();
        redrawMotionSensors(true);
    }
}

/**
 *
 * @param {number} x
 * @param {number} y
 * @param {number} roomId
 * @param {Product} product
 * @param {function(Device, string, Serial?): any} callback
 * @param {boolean} alone
 * @param {Serial} targetSerial
 * @param {number} angle
 * @param {boolean} placedByWizard
 * @param {boolean} placedByChange
 * @param {boolean} tryAddon
 * @param {boolean} forceSerialDisplacement
 */
export function placeDevice(x, y, roomId, product, callback = null,
    alone = true, targetSerial = null, angle = 0,
    placedByWizard = false, placedByChange = false, tryAddon = false,
    forceSerialDisplacement = false, overrideSerialParams) {
  const originalProductId = product.id;
  const numericalProductId = product.id.replace("product_", "");

  showDragAndDropOverlay(false);
  const isModify = canModifyProjectByRoomId(roomId);

  const canPutDifferentDevice = canPutDifferentDeviceByRoomId(roomId,
      originalProductId, numericalProductId);

  if (!isModify) {
    toastNotProError();
    return;
  }

  if (!canPutDifferentDevice) {
    snackError(ts('not_mix_automation',
        "Only one type of automation system can be used in a project."));
    return;
  }

  // TODO: moveplannercode-deadcode — placeDevice is never called with "new_note"; sole-note drop now dispatches onNoteDrop → React AddNoteDialog (#352)
  if (numericalProductId === "new_note") {
    showAddSoleNoteModal(x, y, callback);
    return;
  }

  // leszedjuk a merged eszközökről a színezést
  $('.device').removeClass('merged-highlight');

  var room = getRoomById(roomId);

  var preventNote = !!product.prevent_note;
  var noteToAddAfter = null;
  if (product.note_message) {
    noteToAddAfter = product.note_message;
  }
  if (!(targetSerial || canBeDevMerged(numericalProductId)) && !placedByWizard
      && !placeFree(x, y)) {
    if (typeof callback === "function") {
      callback(false);
    }
    return;
  }

  angle = uMath.normalizeAngle(angle);
  var isCabinet = product && (product.id == "electrical_cabinet" || product.id
      == "rack_cabinet");

  if (isCabinet) {
    product.image = product.icon;
  }
  unHighlight();
  if (!placedByWizard && !targetSerial && !doesDeviceFitRoom(room.id,
      {x: x, y: y}, angle)) {
    if (isPointOutOfBounds({x, y})) {
      snackError(ts('p_dev_out_of_bounds_err',
          'Make sure the device is inside the area marked by the dashed lines.'));
    } else {
      snackError(ts('p_dev_wall_intersect_err',
          "Make sure the device doesn't intersect any walls."));
    }
    if (typeof callback === "function") {
      callback(false);
    }
    return;
  }
  if (room.id === uDev.OUTDOORS_ROOM_ID && isCabinet) {
    snackError(
        ts("p_outdoor_cabinet_inside", "Cabinets can only be placed in rooms."));
    if (typeof callback === "function") {
      callback(false);
    }
    return;
  }

  var firstInRoom = firstOfType(numericalProductId, roomId);
  if (firstInRoom && firstInRoom.ghost && !placedByWizard) {
    if (typeof callback === "function") {
      callback(false);
    }
    return;
  }
  //the device that will be saved to the device array - could be modified later on
  var fakeDevId = 'fake_' + PlannerGlobals.curr_fake_devid--;
  var newdev = {
    x: x,
    y: y,
    roomId: +roomId,
    deviceId: fakeDevId,
    fakeDeviceId: fakeDevId,
    image: product.image,
    input: product.input,
    serializable: product.serializable,
    max_serializable: product.max_serializable,
    groupable: product.groupable,
    category_id: +product.parent.replace('category_', ''),
    product_name_id: +numericalProductId,
    ghost: true,
    nopermission: false,
    is_loxone: product.is_loxone,
    has_design: product.has_design,
    is_nhc: product.is_nhc,
    product_id: product.product_id,
    image_url: product.image_url,
    device_manufacturer: product.device_manufacturer,
    mergeable: product.mergeable,
    device_color: product.device_color,
    angle: angle,
    type: isCabinet ? product.id.replace('_', ' ') : null,
    placedByChange: placedByChange
  };
  newdev.initialFakeDeviceId = newdev.deviceId;

  if (firstInRoom) {
    firstInRoom.ghost = true;
  }
  if (!isCabinet) {
    delete newdev.type;
  }
  PlannerGlobals.devices = PlannerGlobals.devices.concat([newdev]);

  const isSingleMerged = !newdev.serializable && isDeviceMergedById(
      +numericalProductId);

  if (targetSerial) {
    var tarSerDev = getDeviceById(targetSerial.deviceIds[0]);

    if (tarSerDev) {
      // props before adding new dev
      const conn = getSerialConnectionForSerialId(targetSerial.id);
      const d3Obj = conn ? getSerialConnectionProps(conn.id) : getSerObj(
          targetSerial);
      const oriTopMid = getD3DevTopCenter(d3Obj);
      const tarSerOriLen = serialRealLength(targetSerial);

      targetSerial.deviceIds.push(newdev.deviceId);

      if (!placedByWizard || forceSerialDisplacement) {

        const connectedPair = getSerialConnectedPair(targetSerial.id);
        const connPairHorizLen = connectedPair ? (connectedPair.direction
        === "horizontal" ? serialRealLength(connectedPair) : 1) : 0;

        if (!connectedPair || connPairHorizLen <= tarSerOriLen
            || targetSerial.direction === "vertical") {
          if (!serialAlreadyContainsBadgedDevType(targetSerial, newdev)) {

            if (isPointSnapped(oriTopMid)) {
              const newD3Obj = conn ? getSerialConnectionProps(conn.id)
                  : getSerObj(targetSerial);
              const rows = getDRowsNum(newD3Obj);
              const cols = getDColsNum(newD3Obj);

              const snappedPt = snapDeviceToWall(oriTopMid,
                  PlannerGlobals.DEVICE_SIZE * 10, cols, false, undefined,
                  undefined, undefined, undefined, rows);
              if (snappedPt) {
                tarSerDev.x = snappedPt.point.x;
                tarSerDev.y = snappedPt.point.y;
                tarSerDev.angle = snappedPt.rotation;
                tarSerDev.roomId = snappedPt.room.id;
              }
            } else {
              if (targetSerial.direction === "horizontal") {
                tarSerDev.x -= PlannerGlobals.DEVICE_SIZE / 2 + SERIAL_SPACING
                    / 2;
              } else {
                tarSerDev.y -= PlannerGlobals.DEVICE_SIZE / 2 + SERIAL_SPACING
                    / 2;
              }
            }

          }

          setAndSendSerialPosition(targetSerial.id, tarSerDev);
          if (connectedPair) {
            setAndSendSerialPosition(connectedPair.id, tarSerDev);
          }

        }
      }
      x = newdev.x = tarSerDev.x;
      y = newdev.y = tarSerDev.y;
      angle = newdev.angle = tarSerDev.angle;
      roomId = newdev.roomId = tarSerDev.roomId;
    } else if (isSingleMerged) {
      const firstOcc = getFirstOccurrenceOfDev(newdev);
      if (firstOcc) {
        x = newdev.x = firstOcc.x;
        y = newdev.y = firstOcc.y;
        angle = newdev.angle = firstOcc.angle;
        roomId = newdev.roomId = firstOcc.roomId;
      }
    }
  }
  //the data that will be sent to the server - probably won't get modified
  var sendData = {
    x: x,
    y: y,
    room_id: roomId,
    product_name_id: numericalProductId,
    device_alone: alone ? 1 : 0
  };

  // ha rádobjuk egy mási keszközre
  const merge = getMergedDevice(newdev);
  if (merge !== null) {
    sendData.merged_device_id = merge.deviceId;
  }

  var sendURL = ROOT_URI + '/device';
  if (isCabinet) {
    if (product.id == "rack_cabinet") {
      sendData.item_type = 1;
    } else if (product.id == "electrical_cabinet") {
      sendData.item_type = 2;
    }
    sendData.rotate_value = angle;
    sendURL = ROOT_URI + '/floor/additional-item';
    newdev.item_type = sendData.item_type;
    newdev.type = product.id.replace("_", " ");
  } else if (product.type === "custom_device") {
    sendURL = ROOT_URI + '/user-custom-items/room-user-custom-item';
    sendData.user_custom_item_id = product.id.replace("user_custom_item_", "");
    sendData.rotate_value = angle;
    newdev.angle = angle;
    newdev.user_custom_item_id = product.id.replace("user_custom_item_", "");
  }

  // TODO: REMOVE THIS AFTER UNASSIGNED AJAX
  /* if (sendData.room_id == uDev.UNASSIGNED_ROOM_ID) {
        console.debug('DEBUG: Replaced unassigned room id with outdoor room id');
        sendData.room_id = uDev.OUTDOORS_ROOM_ID;
    } */

  if (!placedByWizard) {
    redrawDevice(newdev.deviceId);
  }

  getAuthHeader(function (header) {
    $.ajax({
      headers: header,
      type: 'POST',
      url: sendURL,
      dataType: 'JSON',
      data: sendData,
      success: function (response) {
        newdev.placedByChange = false;
        var realDevId = parseInt(response.id);

        if (isCabinet) {
          realDevId = 'S_' + realDevId;
        } else if (product.type == "custom_device") {
          realDevId = 'C_' + realDevId;
        }
        if (targetSerial) {
          for (var i = 0; i < targetSerial.deviceIds.length; i++) {
            let devId = targetSerial.deviceIds[i];
            if (devId == newdev.deviceId) {
              targetSerial.deviceIds[i] = realDevId;
            }
          }
        }

        if (response.image_url) {
          newdev.image_url = response.image_url;
        }

        if (response.merged_device) {
          PlannerGlobals.mergedDevice = response.merged_device
        }

        var oldId = newdev.deviceId;
        newdev.deviceId = realDevId;
        newdev.symbol_id = response.symbol_id;
        if (response.note_message) {
          newdev.noteId = response.default_note_id;
          newdev.noteTxt = response.note_message;
          newdev.hasNote = true;
          newdev.noteColor = "#fffcc9";
          if (preventNote) {
            deleteDevNote(newdev);
            newdev.noteId = null;
            newdev.noteTxt = null;
            newdev.hasNote = false;
          }
        }
        newdev.ghost = false;
        if (firstInRoom) {
          firstInRoom.ghost = false;
        }

        var newSerial = null;
        if (response.new_serial_id) {
          if (!targetSerial) {
            newSerial = {
              id: +response.new_serial_id,
              deviceIds: [newdev.deviceId],
              angle: angle,
              height: overrideSerialParams ? overrideSerialParams.height
                  : getSerialHeightForPNID(newdev.product_name_id),
              direction: overrideSerialParams ? overrideSerialParams.direction
                  : 'horizontal',
            }
            PlannerGlobals.serials.push(newSerial);
            ajaxSetSerialProps(newSerial);

          } else if (targetSerial) {
            targetSerial.id = +response.new_serial_id;
            targetSerial.deviceIds.push(newdev.deviceId);
            ajaxSetSerialProps(targetSerial);
          }
        }

        if (!placedByWizard) {
          redrawDevice(newdev.deviceId);
        }

        if (angle != 0) {
          if (placedByWizard || alone || !targetSerial) {
            var first = getFirstOccurrenceOfDev(newdev);
            if (first.deviceId == newdev.deviceId) {
              var putdata;
              if (!placedByWizard) {
                if (response.new_serial_id) {
                  putdata = d3.select(
                      '[data-serialId="' + response.new_serial_id
                      + '"]').datum();
                } else {
                  putdata = d3.select(
                      '[data-serDevId="' + realDevId + '"]').datum();
                }
              } else {
                putdata = {
                  roomId: newdev.roomId,
                  x: newdev.x,
                  y: newdev.y,
                  devices: [{
                    x: newdev.x,
                    y: newdev.y,
                    roomId: newdev.roomId,
                    deviceId: realDevId,
                    angle: newdev.angle
                  }]
                };
                if ("user_custom_item_id" in newdev) {
                  putdata.devices[0].user_custom_item_id = newdev.user_custom_item_id;
                }
                if (newdev.type) {
                  putdata.devices[0].type = newdev.type;
                  putdata.devices[0].item_type = newdev.item_type;
                }
              }
              PUTDevData(putdata, placedByWizard);
            } else {
              updateDev(newdev);
            }
          } else {
            updateDev(newdev);
          }
        }

        if (!preventNote) {
          if (noteToAddAfter && !newdev.noteTxt) {
            var strId = newdev.deviceId + "";
            var type = strId.indexOf('C_') === 0 ? 3 : 2;
            newdev.noteTxt = noteToAddAfter;
            sendDevNote(type, "#fffcc9", noteToAddAfter, strId, newdev);
          } else if (noteToAddAfter && newdev.noteTxt && noteToAddAfter
              != newdev.noteTxt) {
            newdev.noteTxt = noteToAddAfter;
            modDevNote(newdev, "#fffcc9", noteToAddAfter);
          }
        }

        if (!placedByWizard) {
          refreshFloorView();
        }

        if (targetSerial && !alone) {
          addDevToSerial(realDevId, targetSerial, function () {
            if (doesSerialFitRoom(targetSerial.id) || placedByWizard) {
              if (callback) {
                callback(newdev, response, targetSerial);
              }
            } else {
              var origiWallsCache = UDevGlobals.WALLS_CACHE;
              UDevGlobals.WALLS_CACHE = wallsOfRoom(room);
              var serLen = serialRealLength(targetSerial);
              var snapped = snapDeviceToWall({x, y},
                  PlannerGlobals.DEVICE_SIZE * 10, serLen);
              UDevGlobals.WALLS_CACHE = origiWallsCache;
              if (snapped) {
                var action = new MoveDeviceAction(newdev.deviceId, newdev,
                    snapped.point,
                    newdev.roomId, snapped.room.id, newdev.angle,
                    snapped.rotation, [], []);
                action.execute(function () {
                  if (callback) {
                    callback(newdev, response, targetSerial);
                  }
                });
              } else {
                checkTooBigDevices();
                if (callback) {
                  callback(newdev, response, targetSerial);
                }
              }

            }

            !placedByWizard && devicesChanged();
          });
        } else if (newSerial) {
          if (callback) {
            callback(newdev, response, newSerial);
          }
          !placedByWizard && devicesChanged();
        } else {
          const addonPnid = devNeedsAddon(newdev);
          if (tryAddon && addonPnid) {
            const newdevCenter = uDev.getCenterOfDevice_NoDOM(newdev.deviceId);
            const suitablePlace = getSuitablePlaceNearby(newdevCenter,
                newdev.angle);
            const addonProduct = getProductById(addonPnid);
            if (suitablePlace) {
              placeDevice(suitablePlace.point.x, suitablePlace.point.y,
                  suitablePlace.room.id, addonProduct, (newAddonDev) => {
                    if (newAddonDev) {
                      mouseupGroup(newAddonDev.deviceId, newdev.deviceId,
                          () => {
                            toastInfoImportantSingle(ts('shading_switch_check',
                                    'Please check placed switch for shading'),
                                false, 'shading_switch_check')
                            if (callback) {
                              callback(newdev, response, null, newAddonDev);
                            }
                          });
                    }
                  }, undefined, undefined, suitablePlace.rotation);
            } else if (callback) {
              callback(newdev, response);
            }
          } else if (callback) {
            callback(newdev, response);
          }
          !placedByWizard && devicesChanged();
        }
        showDragAndDropOverlay();
      },
      error: function (response) {
        for (var i = 0; i < PlannerGlobals.devices.length; i++) {
          var currdev = PlannerGlobals.devices[i];
          if (currdev.deviceId == newdev.deviceId) {
            PlannerGlobals.devices.splice(i, 1);
            break;
          }
        }

        if (firstInRoom) {
          firstInRoom.ghost = false;
        }

        removeDeviceFromSerial(newdev.deviceId);

        if (!placedByWizard) {
          if (response && response.responseJSON
              && response.responseJSON.message) {
            snackError(response.responseJSON.message);
          }
        }
        var firstOcc = getFirstOccurrenceOfDev(newdev);
        if (firstOcc) {
          firstOcc.ghost = false;
        }
        newdev.deleted = true;
        redrawDevice(newdev.deviceId);

        if (callback) {
          var respMsg = response && response.responseJSON
          && response.responseJSON.message ? response.responseJSON.message : '';
          callback(false, respMsg);
        }
      }
    });
  });
}

/**
 * Removes a device from the planner
 *
 * @param {any} redX The Red X element that sent the request
 * @param {any} deviceId The device's Id
 */
export function removeDevice(redX, deviceId, deletedByWizard = false,
    allowSerialDisplacement = false) {
  var def = $.Deferred();

  var origiDevId = deviceId;

  unHighlight();
  hideRotateAndDeviceTools();
  //find out if the device is stored locally (it should be)
  let deleteIndex = PlannerGlobals.devices.findIndex(function (device) {
    return device.deviceId == deviceId;
  });
  const origiDev = PlannerGlobals.devices[deleteIndex];

  if (deleteIndex != -1) {
    removeDeviceFromCanPutDifferentDeviceByRoomIdCache(origiDev.roomId,
        origiDev.product_name_id);
    if (isDeviceMerged(PlannerGlobals.devices[deleteIndex])
        && !PlannerGlobals.devices[deleteIndex].serializable) {
      //for (var i = mergedDevice.length - 1; i >= 0; i--) {
      for (var i = 0; i < PlannerGlobals.mergedDevice.length; i++) {

        // az összemergeltek közül az utolsó
        if (PlannerGlobals.mergedDevice[i].merge_plan_objects_id
            === PlannerGlobals.devices[deleteIndex].deviceId) {
          deviceId = PlannerGlobals.mergedDevice[i].merged_plan_objects_id;
        }
      }

      for (i = 0; i < PlannerGlobals.devices.length; i++) {
        if (deviceId === PlannerGlobals.devices[i].deviceId) {
          deleteIndex = i;
        }
      }
    } else if (isDeviceMerged(PlannerGlobals.devices[deleteIndex])
        && PlannerGlobals.devices[deleteIndex].serializable) {

      // TODO szerintem ide soha nem futunk be
      var ser = getSerialOfDeviceId(
          PlannerGlobals.devices[deleteIndex].deviceId);
      if (ser) {
        var serDevs = devicesOfSerial(ser.id);
        for (var i = serDevs.length - 1; i >= 0; i--) {
          if (serDevs[i].product_name_id
              == PlannerGlobals.devices[deleteIndex].product_name_id &&
              !serDevs[i].ghost) {
            deviceId = serDevs[i].deviceId;
            deleteIndex = PlannerGlobals.devices.findIndex(function (dev) {
              return dev.deviceId === deviceId;
            });
            break;
          }
        }
      }
    }

    var deleteDev = PlannerGlobals.devices[deleteIndex];
    origiDev.ghost = true;
    origiDev.deleting = true;
    deleteDev.ghost = true;
    deleteDev.deleting = true;

    if (!deletedByWizard) {
      redrawDevice(origiDevId);
    }

    var isCabinet = 'type' in deleteDev && deleteDev.type.toString().indexOf(
        "cabinet") != -1;
    var isCustom = deleteDev.deviceId.toString().indexOf("C_") == 0;
    var sendURL = ROOT_URI + '/device';
    var sendData = {plan_object_id: +deviceId};

    if (isCabinet) {
      sendURL = ROOT_URI + '/floor/additional-item';
      sendData = {additional_item_id: +deviceId.toString().replace('S_', '')};
    }

    if (isCustom) {
      sendURL = ROOT_URI + '/user-custom-items/room-user-custom-item';
      sendData = {
        room_user_custom_item_id: +deviceId.toString().replace("C_", "")
      };
    }

    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: sendURL,
        type: 'DELETE',
        dataType: 'JSON',
        data: sendData,
        success: function (response) {
          if (response.merged_device) {
            PlannerGlobals.mergedDevice = response.merged_device;
          }
          origiDev.ghost = false;
          origiDev.deleting = false;
          var devCpy = deepCopy(deleteDev);
          deleteDev.ghost = false;
          deleteDev.deleting = false;
          deleteDev.deleted = true;
          var ser = getSerialOfDeviceId(deviceId);
          var serConn = ser && getSerialConnectionForSerialId(ser.id);
          var serMeasures = ser && getMeasurementsOfSerial(ser.id);
          var origiGroups = getGroupsOfDevice(deviceId);
          var origiSerial = getSerialOfDeviceId(deviceId);
          var origiNote = getNote(deviceId, "dev");
          var origiSerialConnection = origiSerial
              ? getSerialConnectionForSerialId(origiSerial.id) : null;
          removeDeviceFromGroupsLocal(deviceId);
          var wasLastOfSerial = !!removeDeviceFromSerial(deviceId, false,
              deletedByWizard, allowSerialDisplacement);
          var removedMeasures = removeDeviceFromMeasuresLocal(deviceId);
          if (ser && wasLastOfSerial) {
            removedMeasures = removedMeasures.concat(serMeasures);
          }
          if (serConn && wasLastOfSerial) {
            PlannerGlobals.serialConnections = PlannerGlobals.serialConnections.filter(
                sc => sc.id != serConn.id);
            //FAKE_removeSerConnProps(serConn.id);
          }
          PlannerGlobals.devices = PlannerGlobals.devices.filter(
              function (device) {
                return device.deviceId != deviceId;
              });
          recalcSwitchPNIDs();
          requestAnimationFrame(function () {
            if (!deletedByWizard) {
              redrawDevice(origiDevId);
              refreshFloorView();
              if (isMotionSensorOrCamera(devCpy) && isMotionSensorMode()) {
                redrawMotionSensors(true);
              }
            }
            if (PlannerGlobals.sizeErrorHelper.errorCorrectMode
                && areProblemsFixed()) {
              enderrorCorrectMode();
            }
            devicesChanged();

            removeDeviceFromCacheLocal(deleteDev);

            def.resolve({
              device: devCpy,
              groups: origiGroups,
              serial: origiSerial,
              serialConnection: origiSerialConnection,
              note: origiNote,
              wasLastOfSerial: wasLastOfSerial,
              removedMeasures: removedMeasures
            });
          });
          redrawDevices();
          showDragAndDropOverlay();
        },
        error: function (response) {
          if (response.responseJSON && response.responseJSON.message
              && !deletedByWizard) {
            snackError(response.responseJSON.message);
          }
          origiDev.ghost = false;
          origiDev.deleting = false;
          if (deleteDev) {
            deleteDev.deleting = false;
            deleteDev.ghost = false;
          }
          if (!deletedByWizard) {
            redrawDevices();
            /* redrawDevice(); */
          }
          def.reject(response.responseJSON.message);
        }
      });
    });
  } else {
    def.reject();
  }
  return def;
}

export class PlaceDeviceBuilder {
    constructor() {
        this.point = null;
        this.roomId = null;
        this.product = null;
        this.callback = null;
        this.alone = true;
        this.targetSerial = null;
        this.angle = 0;
        this.placedByWizard = false;
        this.placedByChange = false;
        this.tryAddon = false;
        this.forceSerialDisplacement = false;
    }
    setPoint(point) {
        this.point = point;
        return this;
    }
    setRoomId(roomId) {
        this.roomId = roomId;
        return this;
    }
    setProduct(product) {
        this.product = product;
        return this;
    }
    setCallback(callback) {
        this.callback = callback;
        return this;
    }
    setAlone(alone) {
        this.alone = alone;
        return this;
    }
    setTargetSerial(targetSerial) {
        this.targetSerial = targetSerial;
        return this;
    }
    setAngle(angle) {
        this.angle = angle;
        return this;
    }
    setPlacedByWizard(placedByWizard) {
        this.placedByWizard = placedByWizard;
        return this;
    }
    setPlacedByChange(placedByChange) {
        this.placedByChange = placedByChange;
        return this;
    }
    setTryAddon(tryAddon) {
        this.tryAddon = tryAddon;
        return this;
    }
    setForceSerialDisplacement(forceSerialDisplacement) {
        this.forceSerialDisplacement = forceSerialDisplacement;
        return this;
    }
    setOverrideSerialParams(overrideSerialParams) {
        this.overrideSerialParams = overrideSerialParams;
        return this;
    }
    run() {
        placeDevice(this.point.x, this.point.y, this.roomId, this.product, this.callback, this.alone, this.targetSerial,
            this.angle, this.placedByWizard, this.placedByChange, this.tryAddon, this.forceSerialDisplacement, this.overrideSerialParams);
    }
}
